 <router-outlet></router-outlet> 
 <app-alert [sender]="sender"></app-alert>
 